import { Icon } from 'common/icon';
import clsx from 'clsx';
import styles from './styles.module.css';

export interface CheckboxProps {
  label?: string;
  disabled?: boolean;
  checked?: boolean;
  checkedIcon?: React.ReactNode;
  onChange?: () => void;
}

export const Checkbox = ({
  disabled,
  checked = false,
  checkedIcon = <Icon.Checkmark />,
  onChange,
  ...props
}: CheckboxProps): React.JSX.Element => {
  const handleChange = () => {
    if (!disabled) {
      if (onChange) {
        onChange();
      }
    }
  };

  return (
    <label className={styles.container}>
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        className={styles.styledCheckbox}
        onChange={handleChange}
        {...props}
      />
      <div>
        <span
          className={clsx(styles.checkboxMark, { [styles.checked]: !checked })}
        >
          {checkedIcon}
        </span>
      </div>
    </label>
  );
};
